import { Component } from '@angular/core';
import { fuseAnimations } from '../../../../../../../../../../../../core/animations';


@Component({
    selector: 'credibility',
    templateUrl: './credibility.component.html',
    styleUrls: ['./credibility.component.scss'],
    animations: fuseAnimations
})

export class CredibilityComponent {

    constructor(
    ) {

    }

    ngOnInit() {

    }

    ngOnDestroy() {

    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/pros/user-info/details/tabs/credibility-center/credibility.component.ts